import { IMutation } from '@/store/types/mutation'
import { SET, UNSET } from './mutations-types'
import { IState } from './types'

interface IInputLoading {
  namespace: string,
  inputId: string
}

const set: IMutation<IState, IInputLoading> = (state, { namespace, inputId }) => {
  state.loadingInputs.push(`${namespace}_${inputId}`)
  state.loadingInputs = state.loadingInputs
}

const unset: IMutation<IState, IInputLoading> = (state, { namespace, inputId }) => {
  const inputToRemove: string = `${namespace}_${inputId}`
  const filteredState = state.loadingInputs.filter((i) => i !== inputToRemove)
  state.loadingInputs = filteredState
}

export default {
  [SET]: set,
  [UNSET]: unset,
}
